import React, { useState, useEffect } from "react";
import _ from "lodash";
import ProductsManager from "../../modules/productManager";
import { Collapse } from "antd";
import SearchBar from "./SearchBar";
import ProductsChart from "../charts/ProductsChart";
import ProductsBarChart from "../charts/ProductsBarChart";
import "./Products.css";
import { ProductTable } from "./table/ProductsTable";

const Products = ({
  searchTerm,
  changeSearchTerm,
  locationBoolean,
  routerProps,
}) => {
  const [products, setAllProducts] = useState(null);
  const [selectedCategory, changeCategory] = useState("all");
  const [search, setSearch] = useState(null);
  const [filteredCount, setFilteredCount] = useState([]);

  const getProducts = async (
    pageNumberParameter = "all",
    category = selectedCategory,
    search = searchTerm
  ) => {
    const products = await ProductsManager.getProducts(
      pageNumberParameter,
      category,
      search
    );
    const orderedProducts = _.orderBy(products, "created_at", "desc");
    setAllProducts(orderedProducts);
  };

  function productFilterUltraFunction() {
    const productSearchTerm = search ? search.toLowerCase() : null;
    if (search == "") {
      return products;
    } else if (search !== null) {
      const filtered = products.filter((product) => {
        const firstName = product.member.user.first_name
          .toString()
          .toLowerCase();
        const lasttName = product.member.user.last_name
          .toString()
          .toLowerCase();
        if (
          product.title?.toLowerCase()?.includes(productSearchTerm) ||
          product.price?.toLowerCase()?.includes(productSearchTerm) ||
          product.duration?.toLowerCase()?.includes(productSearchTerm) ||
          product.location?.toLowerCase()?.includes(productSearchTerm) ||
          product.quality?.toLowerCase()?.includes(productSearchTerm) ||
          product.created_at?.toLowerCase()?.includes(productSearchTerm) ||
          product.product_type.name
            .toString()
            .toLowerCase()
            .includes(productSearchTerm) ||
          firstName.match(productSearchTerm) ||
          lasttName.match(productSearchTerm) ||
          `${firstName} ${lasttName}`.match(productSearchTerm)
        ) {
          return product;
        }
      });
      return filtered;
    }
  }

  function ProductsDataCards() {
    if (products && !search) {
      return <ProductTable data={products} />;
    } else if (products && search) {
      const filteredProducts = productFilterUltraFunction();
      return <ProductTable data={filteredProducts} />;
    }
  }

  function Count() {
    if (products && !search) {
      const productsCount = products.length;
      return productsCount;
    } else if (products && search) {
      const productsCount = productFilterUltraFunction();
      const newProductsCount = productsCount.length;
      return newProductsCount;
    }
  }

  useEffect(() => {
    getProducts();
  }, []);

  const { Panel } = Collapse;

  return (
    <div className="main-title">
      <h1>Product Data</h1>
      <ProductsChart />
      <ProductsBarChart />
      <h2>All Products</h2>
      <h3>Count: {Count()}</h3>
      <SearchBar setSearch={setSearch} searchTerm={searchTerm} />
      <div className="products-cards">{ProductsDataCards()}</div>
    </div>
  );
};

export default Products;
